export default "__VITE_ASSET__e3d80f86__"